import React from "react";

// // // //

export function ClassnamePassthruWrapper(props: {
    className: string | null | undefined;
    children: React.ReactNode;
}) {
    const { className, children } = props;

    if (!className) {
        return <>{children}</>;
    }

    return <div className={className}>{children}</div>;
}
